<template>
  <div class="page-container">
    <MainTitle
      title="Chatting Experience"
      message="Let's write with your style!"
    />
    <div class="app-content-container">
      <v-card
        variant="outlined"
        max-width="1000"
      >
        <v-container>
          <v-select
            v-model="language"
            label="Choose your language"
            :items="languageList"
          />
        </v-container>
        <v-container>
          <v-select
            v-model="subject"
            label="Choose a subject"
            :items="subjectList"
            item-title="subject_name"
            item-value="id"
            return-object
            single-line
          />
        </v-container>
        <v-container>
          <v-select
            v-model="tone"
            label="Choose the tone of your writing"
            :items="toneList"
          />
        </v-container>
        <v-container>
          <div class="card">
            <Editor
              editor-style="height: 320px"
              @text-change="textChange"
            />
          </div>
        </v-container>
        <v-card-actions>
          <v-btn
            :disabled="improveTextBtnDisabled"
            @click="improveText"
          >
            Style my writing
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-textarea
            v-model="outputText"
            rows="10"
            label="Generated text will be displayed here"
            outlined
          />
        </v-card-text>
      </v-card>
    </div>
    <div>
      <ChatBot :subject="subject" />
    </div>
  </div>
</template>

<script>
import ChatBot from "@/components/chatbot/ChatBot";
import MainTitle from "@/components/title/MainTitle.vue";
import { sidebarWidth } from '@/components/sidebar/state';
import Editor from 'primevue/editor';

import {
  BASE_URL,
  STYLE_WRITING_API_ENDPOINT,
  LIBRARY_SUBJECT_ENDPOINT
} from "../assets/constants/api_endpoints.js";
import { getWithAuthentication, postWithAuthentication } from "@/services/api";

export default {
  components: {
    MainTitle,
    ChatBot,
    Editor
  },
  setup() {
    return {
      sidebarWidth
    }
  },
  data() {
    return {
      inputText: "",
      outputText: "",
      writingMode: "You're writing in Free Style Mode",
      language: "English",
      languageList: ["English", "Arabic", "Japanese", "French"],
      tone: "Clear Tone",
      toneList: ["Clear Tone"],
      subject: "",
      subjectList: []
    };
  },
  computed: {
    improveTextBtnDisabled() {
      return this.inputText ? false : true;
    },
    subjectNameList() {
      return this.subjectList.map((element) => element.subject_name)
    }
  },
  async beforeMount() {
    await this.getSubjectList();
    if (this.subjectList.length > 0) {
      this.subject = this.subjectList[0]
    }
  },
  methods: {
    async getSubjectList() {
      try {
        const response = await getWithAuthentication(
          BASE_URL,
          LIBRARY_SUBJECT_ENDPOINT
        );
        if (response && response.status === 200) {
          let data = response.data;
          if (data) {
            this.subjectList = data.filter(item => item.is_deleted == false)
          }
        }
      } catch (error) {
        this.$router.push({ name: "LoginForm", params: { loggedOut: true } });
      }
    },
    textChange(event) {
      this.inputText = event.textValue;
    },
    improveText: async function () {
      if (this.inputText === "" || this.tone === "") {
        return;
      }
      const params = { text: this.inputText, tone: this.tone };
      const response = await postWithAuthentication(BASE_URL, STYLE_WRITING_API_ENDPOINT, params);
      this.outputText = response["improved_text"];
    },
  },
};
</script>

<style>
.app-main-menu {
  padding-top: 10px;
  position: absolute;
  height: 100%;
}

.writing-space-title {
  font-family: "Trebuchet MS", Helvetica, sans-serif;
  font-size: 50px;
  font-style: italic;
}
</style>
